module.exports = __webpack_public_path__ + "static/media/DegeneratedHipGroup.5d43eec6.png";